import { http } from "@next-core/http";
/**
 * @description 获取elevo数字人列表
 * @endpoint list /api/v1/elevo/ai-employees
 */
export const ElevoApi_listElevoAiEmployees = async (params, options) => /**! @contract easyops.api.llm.elevo.ListElevoAiEmployees@1.0.0 */(await http.get("api/gateway/logic.llm.aiops_service/api/v1/elevo/ai-employees", {
  ...options,
  params
})).data;
//# sourceMappingURL=listElevoAiEmployees.js.map